const complaintDetailsDialogStyle = () => ({
	dialogWrapper: {
		paddingBottom: 60,
		'& > div > div': {
			marginLeft: 'auto',
			marginRight: 'auto',
		},
	},
	circularProgressWrapper: {
		padding: '10px 0 50px 0',
	},
});

export default complaintDetailsDialogStyle;
